import { createAction } from 'shared';

export const fetchQRCode = createAction('FETCH_QR_CODE', 'ids', 'entities');
